import { render, staticRenderFns } from "./japanese_radio_cateList.vue?vue&type=template&id=118e934d&scoped=true"
import script from "./japanese_radio_cateList.vue?vue&type=script&lang=js"
export * from "./japanese_radio_cateList.vue?vue&type=script&lang=js"
import style0 from "./japanese_radio_cateList.vue?vue&type=style&index=0&id=118e934d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e934d",
  null
  
)

export default component.exports